import { FC } from 'react'

import { AppButton } from '@/components/shared/button'

type Props = {
  text: string
  closeDrawer: () => void
  onCancel: () => void
  backButtonText?: string
  cancelButtonText?: string
}

const StepConfirmContent: FC<Props> = ({
  text,
  closeDrawer,
  onCancel,
  backButtonText = 'Вернуться назад',
  cancelButtonText = 'Отмена'
}) => {
  return (
    <div className="flex flex-1 flex-col">
      <p className="font-pro text-20 xs:text-18">{text}</p>
      <div className="mt-auto flex flex-col gap-16">
        <AppButton
          className="mt-auto w-full"
          variant="primary"
          onClick={closeDrawer}
        >
          {backButtonText}
        </AppButton>
        <AppButton
          className="mt-auto w-full"
          variant="tertiary"
          onClick={onCancel}
        >
          {cancelButtonText}
        </AppButton>
      </div>
    </div>
  )
}

export { StepConfirmContent }
